module.exports = __webpack_public_path__ + "static/media/karamlina.af32a6be.jpg";